export enum govevaLinks {
    dashboard = "dashboards/alpha",
    rolemaster = "role-master/roleMaster",
    userMaster = "userMaster/userManagement",
    companyMaster = "companymaster",
    structure = "structure"
}